import {Box, Item} from 'devextreme-react/box';
import Toolbar, {Item as ToolbarItem} from 'devextreme-react/toolbar';
import {
    ActionHistoryButton,
    ChangeOrderButton,
    CreateEstimateButton,
    CustomerInformationPanel,
    CustomerNotificationsButton,
    ExitButton,
    PlumbingBanner,
    PrintButton,
    RequestCancellationButton,
    RetailOrderCommunicationButton,
    RetailOrderDatesPanel,
    RetailOrderFilesButton,
    RetailOrderInformationPanel,
    RetailOrderNotes,
    RetailOrderPage,
    RetailOrderProducts,
    RetailOrderProgress,
    RetailOrderProgressStep,
    RetailOrderReportType,
    SaveButton,
    StoreInformationPanel,
    ViewChangeRequestButton
} from '../../../features/cfi/retail-order';
import '../../../css/order.scss';
import InformationPanelSelector from "../../../features/cfi/retail-order/components/InformationPanelSelector";

export default function RetailOrderInfoPage() {
    return (

        <RetailOrderPage>

            <PlumbingBanner/>

            <RetailOrderProgress/>

            <Toolbar className='button-toolbar' multiline={true}>
                <ToolbarItem location={'before'}>
                    <SaveButton step={RetailOrderProgressStep.Info}/>
                </ToolbarItem>
                <ToolbarItem location={'before'}>
                    <PrintButton reportType={RetailOrderReportType.Info}/>
                </ToolbarItem>
                <ToolbarItem location={'before'}>
                    <ActionHistoryButton/>
                </ToolbarItem>
                <ToolbarItem location={'before'}>
                    <CustomerNotificationsButton/>
                </ToolbarItem>
                <ToolbarItem location={'before'}>
                    <RetailOrderCommunicationButton/>
                </ToolbarItem>
                <ToolbarItem location={'before'}>
                    <RetailOrderFilesButton/>
                </ToolbarItem>
                <ToolbarItem location={'before'}>
                    <CreateEstimateButton/>
                </ToolbarItem>
                <ToolbarItem location={'before'}>
                    <ChangeOrderButton step={RetailOrderProgressStep.Info}/>
                </ToolbarItem>
                <ToolbarItem>
                    <ViewChangeRequestButton step={RetailOrderProgressStep.Info}/>
                </ToolbarItem>
                <ToolbarItem location={'before'}>
                    <RequestCancellationButton/>
                </ToolbarItem>
                <ToolbarItem location={'before'}>
                    <ExitButton/>
                </ToolbarItem>
            </Toolbar>
            <Box>
                <Item ratio={1}>
                    <RetailOrderInformationPanel
                        showProjectManager={true}
                    />
                </Item>
                <Item ratio={1}>
                    <RetailOrderDatesPanel
                        showScheduledInstallDates={true}
                        showActualInstallDates={true}
                        showInvoiceDate={true}
                        editCabinetDates={true}/>
                </Item>
                <Item ratio={1}>
                    <InformationPanelSelector/>
                </Item>
            </Box>
            <Box>
                <Item ratio={1}>
                    <CustomerInformationPanel/>
                </Item>
                <Item ratio={1}>
                    <StoreInformationPanel/>
                </Item>
            </Box>

            <RetailOrderProducts/>

            <RetailOrderNotes/>

        </RetailOrderPage>
    )
}
